
const state = {
  globalLoader: false,
  windowWidth: 760,
  menuOpened: false
}

const mutations = {
  SET_GLOBAL_LOADER: (state, value) => {
    state.globalLoader = value
  },
  SET_WINDOW_WIDTH: (state, value) => {
    state.windowWidth = value
  },
  SET_MENU_OPENED: (state, value) => {
    console.log('SET_MENU_OPENED', value)
    state.menuOpened = value
  }
}

const getters = {
  GET_GLOBAL_LOADER: (state) => state.globalLoader,
  GET_WINDOW_WIDTH: (state) => state.windowWidth,
  GET_MENU_OPENED: (state) => state.menuOpened
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
